// extracted by mini-css-extract-plugin
export default {"pagination":"mTeionSCn0y4gCaFsHa4","documentImage":"njXX6mXUPVGzZ8OH0YY5","documentActions":"tLf22rRjF5xu6ozk_MQF"};